export class ComprovacaoListaAnualDTO {
  cdMatricula: string;
  nmFuncionario: string;
  tipoBeneficio: string;
  numDepen: number;
  nmDependente: string;
}

